import { AppContext } from "common/context/WithAppWrapper"
import { useContext } from "react"
// @ts-expect-error TS(7016): Could not find a declaration file for module 'reac...
import TagManager from "react-gtm-module"
import { useTranslation } from "react-i18next"
import { useHistory } from "react-router-dom"
import { LOGIN_BACKUP } from "routes/RoutePaths"
import LoginForm from "../../forms/LoginForm"
import "./login.scss"

const tagManagerArgs = {
  gtmId: "GTM-T8X7T37",
}
import.meta.env.MODE !== "development" && TagManager.initialize(tagManagerArgs)

const Login = () => {
  const { t } = useTranslation()
  const history = useHistory()
  const isInterno = history.location.pathname.includes(LOGIN_BACKUP)
  // @ts-expect-error TS(2339): Property 'settings' does not exist on type 'unknow...
  const { settings } = useContext(AppContext)

  return (
    <div className='container-login'>
      <div className='col'>
        <div className='pt-3 offset-sm-0 offset-md-0 offset-lg-1 col-sm-12 col-md-2'>
          <img
            src={settings?.mainLogo}
            alt='logo'
          />
        </div>
      </div>

      <div className='justify-center w-full d-flex'>
        <div className='wrap-login-form tw-w-full lg:tw-w-1/2'>
          <div className='tw-w-4/5 md:tw-w-3/5 z-999'>
            <LoginForm
              // @ts-expect-error TS(2322): Type '{ interno: $TSFixMe; t: TFunction<"translation", ...
              interno={isInterno}
              t={t}
            />
          </div>
        </div>
      </div>
    </div>
  )
}

export default Login
